export enum GroupEnum {
  SUPER_ADMINISTRATOR = 'Super administrador',
  PARTNER = 'Parceiro',
  BROKER = 'Corretor',
  SALES_MANAGER = 'Gerente de vendas',
  MANAGER = 'Gestor',
  SITE = 'Site',
}
